import { Component, inject, Input, ViewChild } from '@angular/core';
import { TruncatePipe } from '../../../pipes/truncate.pipe';
import { MarkdownModule } from 'ngx-markdown';
import { PopoverComponent } from 'src/app/@core/components/ui/popover/popover.component';
import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';
import { SourceNavigationService } from '../../../services/source-navigation.service';

@Component({
  selector: 'app-custom-tooltip',
  standalone: true,
  imports: [PopoverComponent, TruncatePipe, MarkdownModule, IconComponent],
  templateUrl: './custom-tooltip.component.html',
  styleUrl: './custom-tooltip.component.scss'
})
export class CustomTooltipComponent {
  @ViewChild('op') private overlayPanel?: PopoverComponent;

  @Input() public number: string = '';
  @Input() public content: string = '';
  @Input() disableNavigation: boolean = false;

  sourceData!: {
    label: string,
    sourceText: string,
    pageNum: string
  };
  isExpanded = false;
  private isOpen = false;
  private sourceNavigationService = inject(SourceNavigationService);
  private readonly onScrollCapture = () => {
    // During scroll, hover state can get "stuck" open because mouseleave isn't fired.
    if (!this.isOpen) return;
    this.overlayPanel?.hide();
  };

  ngOnInit(): void {
    document.addEventListener('scroll', this.onScrollCapture, { capture: true, passive: true });

    if (this.content) {
      try {
        const parsedContent = JSON.parse(decodeURIComponent(this.content));
        this.sourceData = {
          label: parsedContent?.label || '',
          sourceText: this.cleanSourceText(parsedContent?.sourceText || ''),
          pageNum: parsedContent?.pageNum || ''
        };
      } catch (error) {
        console.error('Failed to parse tooltip content:', this.content, error);
        this.sourceData = {
          label: '',
          sourceText: this.cleanSourceText(this.content),
          pageNum: ''
        };
      }
    } else {
      this.sourceData = {
        label: '',
        sourceText: '',
        pageNum: ''
      };
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.onScrollCapture, { capture: true } as any);
  }

  handlePopoverToggle(isOpen: boolean) {
    this.isOpen = isOpen;
    if (isOpen) this.isExpanded = false;
  }

  onTriggerClick(event: MouseEvent) {
    if (this.isOpen) return;
    this.overlayPanel?.show(event);
  }

  toggleText(event: Event) {
    event.stopPropagation();
    this.isExpanded = true;
  }

  navigateToSource(event: Event): void {
    event.stopPropagation();
    this.sourceNavigationService.navigate(
      this.sourceData?.label ?? '',
      this.sourceData?.pageNum ?? ''
    );
  }

  private cleanSourceText(value: string): string {
    return value.replace(/(\r\n|\r|\n)+/g, ' ').replace(/\s+/g, ' ').trim();
  }
}
